import { useState } from "react";
import { HiPlus } from "react-icons/hi";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import { makeRequestAuth, uploadFiles } from "../../_config/api";
import { ToastContainer } from "react-toastify";

export default function AddBankPage() {
    const [form, setForm] = useState({
        name: "",
        bankLogo: "",            // URL
        interest: "",
        loanAmount: "",
        phone: "",
        tenure: "",
        monthly_emi: "",
        details: "",
        reward: "",
        recommended: false,
    });

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        if (name === "bankLogoFile") {
            setForm({
                ...form,
                bankLogoFile: files[0],
                bankLogo: ""
            });
            return;
        }

        if (name === "bankLogo") {
            setForm({
                ...form,
                bankLogo: value,
                bankLogoFile: null
            });
            return;
        }

        setForm({
            ...form,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handelFileUpload = async (e) => {
        const file = e.target.files[0];
        try {
            const res = await uploadFiles({ fieldName: "file", files: [file] });
            if (res.error === true) {
                return showErrorToast(res.message || "Faild To Upload Files!");
            }
            setForm((prev) => ({ ...prev, bankLogo: res.data.imageUrl }));
        } catch (error) {
            console.log("file upload error: ", error);
            showErrorToast(error.message || "Faild To Upload Image Error");
        }
    };

    const validateForm = () => {
        if (!form.name) return "Bank name required";
        if (!form.interest) return "Interest required";
        if (!form.loanAmount) return "Loan amount required";
        if (!form.phone) return "Phone number required";
        if (!form.tenure) return "Tenure required";
        if (!form.monthly_emi) return "Monthly EMI required";
        if (!form.details) return "Details required";


        if (!form.bankLogo) return "Please Upload Bank Image";
        return null;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const error = validateForm();
        if (error) return showErrorToast(error);

        try {
            const res = await makeRequestAuth('post', "/admin/createLoan", form);
            if (res.error === false) {
                showSuccessToast("Bank Added Successfully");
                setForm({
                    name: "",
                    bankLogo: "",
                    interest: "",
                    loanAmount: "",
                    phone: "",
                    tenure: "",
                    monthly_emi: "",
                    details: "",
                    reward: "",
                    recommended: false,
                });
            } else {
                showErrorToast(res.message || "Something went wrong");
            }
        } catch (err) {
            console.error("Error Upload Bank: ", err)
            showErrorToast(err.message || "Server Error");
        }
    };

    return (
        <div className="w-full p-6 space-y-6">
            <ToastContainer />

            <div className="flex items-center mb-6">

                {/* Back Button */}
                {/* <button
                    className="mr-4 flex items-center justify-center w-10 h-10 rounded-xl bg-[#F8F8EC] text-[#434646] shadow hover:bg-[#e9e9dd] transition"
                    title="Go Back"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        className="w-6 h-6"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M15 19l-7-7 7-7"
                        />
                    </svg>
                </button> */}

                {/* Title Section */}
                <div className="flex flex-col">
                    <h2 className="text-3xl font-bold text-[#434646] leading-none">
                        Add New Loan
                    </h2>
                    <p className="text-sm text-[#749EED] mt-1">
                        Add details for new loan provider
                    </p>
                </div>
            </div>




            <form onSubmit={handleSubmit} className="bg-white p-6 rounded-2xl shadow space-y-6">

                {/* ---- GRID FIELDS ---- */}
                <div className="grid grid-cols-2 gap-5">

                    <div className="col-span-2">
                        <label className="block text-[#434646] font-medium mb-2">Upload Bank Logo</label>

                        {/* Upload Box */}
                        <div className="border-2 border-dashed border-[#749EED] rounded-2xl p-4 cursor-pointer hover:border-[#392DFF] transition">
                            <input
                                type="file"
                                name="bankLogo"
                                className="w-full cursor-pointer"
                                onChange={handelFileUpload}
                            />
                        </div>

                        {/* Preview Box */}
                        {form.bankLogo && (
                            <div className="flex justify-center mt-4">
                                <div className="w-44 h-44 rounded-2xl overflow-hidden shadow-lg border border-[#e5e5e5] bg-white">
                                    <img
                                        src={form.bankLogo}
                                        alt="Preview"
                                        className="w-full h-full object-contain p-2"
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    <input
                        name="name"
                        placeholder="Bank Name"
                        className="border p-3 rounded-xl"
                        value={form.name}
                        onChange={handleChange}
                    />

                    <input
                        name="interest"
                        placeholder="Interest (8.5%)"
                        className="border p-3 rounded-xl"
                        value={form.interest}
                        onChange={handleChange}
                    />

                    <input
                        name="loanAmount"
                        type="number"
                        placeholder="Loan Amount"
                        className="border p-3 rounded-xl"
                        value={form.loanAmount}
                        onChange={handleChange}
                    />

                    <input
                        name="phone"
                        type="number"
                        placeholder="Phone Number"
                        className="border p-3 rounded-xl"
                        value={form.phone}
                        onChange={handleChange}
                    />

                    <input
                        name="tenure"
                        type="number"
                        placeholder="Tenure (Years)"
                        className="border p-3 rounded-xl"
                        value={form.tenure}
                        onChange={handleChange}
                    />

                    <input
                        name="monthly_emi"
                        type="number"
                        placeholder="Monthly EMI"
                        className="border p-3 rounded-xl"
                        value={form.monthly_emi}
                        onChange={handleChange}
                    />

                    <input
                        name="reward"
                        placeholder="Reward Amount"
                        className="border p-3 rounded-xl"
                        value={form.reward}
                        onChange={handleChange}
                    />
                </div>

                {/* DETAILS */}
                <textarea
                    name="details"
                    placeholder="Loan Details"
                    className="border p-3 rounded-xl w-full min-h-[120px]"
                    value={form.details}
                    onChange={handleChange}
                ></textarea>

                {/* Recommended Checkbox */}
                <label className="flex items-center gap-3">
                    <input
                        type="checkbox"
                        name="recommended"
                        checked={form.recommended}
                        onChange={handleChange}
                    />
                    <span className="text-[#434646]">Recommended</span>
                </label>

                {/* SUBMIT BUTTON */}
                <button
                    type="submit"
                    className="bg-[#392DFF] text-white px-5 py-3 rounded-xl flex items-center gap-2 shadow"
                >
                    <HiPlus size={18} /> Add Bank
                </button>
            </form>
        </div>
    );
}
